// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { systemBuilderMiniSplitSpecificationViewStyles } from "@plumberssupply/App/Components/SystemBuilder/SystemBuilderMiniSplitSpecificationView";
import { color, xScreen } from "@plumberssupply/XDL/Utilities";
import { css } from "styled-components";

systemBuilderMiniSplitSpecificationViewStyles.wrapper = {
    css: css`
        display: flex;
        column-gap: 22px;
        row-gap: 20px;
        ${xScreen("lte", 767)} {
            flex-direction: column;
        }
    `,
};

systemBuilderMiniSplitSpecificationViewStyles.leftSectionWrapper = {
    css: css`
        min-width: 308px;
    `,
};

systemBuilderMiniSplitSpecificationViewStyles.leftSection = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 12px;
        border: 1px solid ${color("common.ui7")};
        padding: 12px;
    `,
};

systemBuilderMiniSplitSpecificationViewStyles.rightSection = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        row-gap: 24px;
    `,
};

systemBuilderMiniSplitSpecificationViewStyles.rightSectionWrapper = {
    css: css`
        flex-grow: 1;
    `,
};

systemBuilderMiniSplitSpecificationViewStyles.radioGroup = {
    css: css`
        & > ${TypographyStyle} {
            margin-bottom: 7px;
            font-size: 14px;
            line-height: 22px;
            font-weight: bold;
        }
    `,
};
systemBuilderMiniSplitSpecificationViewStyles.selectOptionMessage = {
    css: css`
        border: 1px solid ${color("common.ui7")};
        background: ${color("common.ui12")};
        min-height: 108px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        line-height: 22px;
        width: 100%;
    `,
};
systemBuilderMiniSplitSpecificationViewStyles.buttonWrapper = {
    css: css`
        border-top: 1px solid ${color("common.ui7")};
        padding-top: 16px;
        display: flex;
        justify-content: flex-end;
        width: 100%;
    `,
};

systemBuilderMiniSplitSpecificationViewStyles.zoneWrapper = {
    css: css`
        width: calc((100% - 98px) / 3);
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};

systemBuilderMiniSplitSpecificationViewStyles.columnSeparator = {
    css: css`
        width: 1px;
        border-left: 1px solid ${color("common.ui7")};
        margin-inline: 24px;
    `,
};
systemBuilderMiniSplitSpecificationViewStyles.rowSeparator = {
    css: css`
        height: 1px;
        width: 100%;
        border-top: 1px solid ${color("common.ui7")};
    `,
};

systemBuilderMiniSplitSpecificationViewStyles.divider = {
    css: css`
        height: 1px;
        width: 1px;
        border-top: 1px solid ${color("common.ui7")};
    `,
};
